//geo, Europe
export const MOCK_SEARCH_COURSES = [
  {
    code: '73434E512Y',
    id: 'course:b51dd6d6-02d9-4aba-97d6-396ed35f3b93',
    name: {
      EN: 'Urban Geography',
      NL: 'Urban Geography',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '73434E511Y',
    id: 'course:a91abd03-365a-40e6-a75e-46cbd2214b94',
    name: {
      EN: 'Political Geography',
      NL: 'Political Geography',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '53248SYG8Y',
    id: 'course:8376db18-7f07-4e95-a56d-e7a05c3302eb',
    name: {
      EN: 'Symplectic Geometry',
      NL: 'Symplectic Geometry',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '900385SCIY',
    id: 'course:ae7124b5-0928-4f33-8d20-90b24337f7ea',
    name: {
      EN: 'Advanced Geosciences',
      NL: 'Advanced Geosciences',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '53341ALG8Y',
    id: 'course:575e103e-1d8d-4526-9dd9-b0cbd6c225de',
    name: {
      EN: 'Algebraic Geometry 1',
      NL: 'Algebraic Geometry 1',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '142413066Y',
    id: 'course:8458f9a1-3dd7-4167-b138-5d3204562587',
    name: {
      EN: 'European Geopolitics',
      NL: 'European Geopolitics',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '53342ALG8Y',
    id: 'course:e576081c-36b2-4151-810c-cd85f7fd4074',
    name: {
      EN: 'Algebraic Geometry II',
      NL: 'Algebraic Geometry II',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '53348DIG8Y',
    id: 'course:fa3bf558-4460-4cdb-8b3e-dd95b98de882',
    name: {
      EN: 'Differential Geometry',
      NL: 'Differential Geometry',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '735420116Y',
    id: 'course:c8982244-68d0-48c5-8e44-8eec24b3d46a',
    name: {
      EN: 'The Geographies of Food',
      NL: 'The Geographies of Food',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '735420008Y',
    id: 'course:481acf9e-93b3-4239-95f8-bbcd3232aaf0',
    name: {
      EN: 'Geographical Perspectives',
      NL: 'Geographical Perspectives',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '73421B008Y',
    id: 'course:44f8f9d2-2825-484b-b0eb-c08cc8a0615b',
    name: {
      EN: 'Geographies of Inequality',
      NL: 'Geographies of Inequality',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '5334AAGR8Y',
    id: 'course:0654f343-999f-4365-b3f9-12b379b2a347',
    name: {
      EN: 'Advanced Algebraic Geometry',
      NL: 'Advanced Algebraic Geometry',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '51228DIF6Y',
    id: 'course:33a34179-7b7d-437c-a5f1-2e7f1d13ed66',
    name: {
      EN: 'Differential Geometry (BSc)',
      NL: 'Differential Geometry (BSc)',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '3854GECRVY',
    id: 'course:a183935f-d291-4a3a-b3c1-a8ab921b3d72',
    name: {
      EN: 'Organised Crime',
      NL: 'Georganiseerde criminaliteit',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '735420009Y',
    id: 'course:9769ff0f-540f-4dff-80a6-b9504bbc2aff',
    name: {
      EN: 'Geo Focus: Fieldwork Excursion',
      NL: 'Geo Focus: Fieldwork Excursion',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '73411B002Y',
    id: 'course:458381cc-48a3-44cb-8dd5-375e6b715bbb',
    name: {
      EN: 'Introduction to Human Geography',
      NL: 'Introduction to Human Geography',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '735420023Y',
    id: 'course:54e588c0-670d-496e-9da2-043e4f213ce7',
    name: {
      EN: 'GEO Track: Master Thesis Project',
      NL: 'GEO Track: Master Thesis Project',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '5132GEIS6Y',
    id: 'course:04d3405b-50ea-4992-a340-4e3229c5920a',
    name: {
      EN: 'Geographical Information Systems',
      NL: 'Geographical Information Systems',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '5264FCG12Y',
    id: 'course:b9eda36a-ae90-4552-9559-46e836ebf9e4',
    name: {
      EN: 'Field Course Geoecological Systems',
      NL: 'Field Course Geoecological Systems',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '73424B013Y',
    id: 'course:8a6e69fe-e73e-42a7-942b-3c5bb8216f94',
    name: {
      EN: 'Human Geography: Theory & Practice',
      NL: 'Human Geography: Theory & Practice',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '735420241Y',
    id: 'course:3673d753-4c9b-4e79-8477-d7262da5e550',
    name: {
      EN: 'Advanced Digital Economic Geography',
      NL: 'Advanced Digital Economic Geography',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '900121SCIY',
    id: 'course:b7fbb4a6-a0f5-4862-802d-b71fc6067730',
    name: {
      EN: 'Introduction to Geological Sciences',
      NL: 'Introduction to Geological Sciences',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '73435E520Y',
    id: 'course:189bc861-7a92-4428-af8d-d9fe40c5833a',
    name: {
      EN: 'Specialisation: Political Geography',
      NL: 'Specialisation: Political Geography',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '73426E502Y',
    id: 'course:509e017b-708c-474e-8811-cf218c9b0286',
    name: {
      EN: 'Geographies of Uneven Digitalization',
      NL: 'Geographies of Uneven Digitalization',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '5264BCIS6Y',
    id: 'course:50ebe8b9-5c0a-430e-84bd-d2c584e577c7',
    name: {
      EN: 'Biogeochemical Cycles in System Earth',
      NL: 'Biogeochemical Cycles in System Earth',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '735420000Y',
    id: 'course:349fe93c-8c95-4e93-b0d9-8f81dc12a095',
    name: {
      EN: 'Master Human Geography General Meetings',
      NL: 'Master Human Geography General Meetings',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '5264SBGE6Y',
    id: 'course:282c690a-548d-4afe-8100-7f2d085adf6d',
    name: {
      EN: 'Science-Based Geo-Ecological Management',
      NL: 'Science-Based Geo-Ecological Management',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '7323C164FY',
    id: 'course:6fa34b5c-740d-4f24-a8a6-e0612f1982dc',
    name: {
      EN: 'Geoeconomic Competition and Global Order',
      NL: 'Geoeconomic Competition and Global Order',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '7340MTH02Y',
    id: 'course:4f0932da-9f56-41fd-8c3e-d86107926260',
    name: {
      EN: 'Matching Human Geography and Planning',
      NL: 'Matching Sociale Geografie en Planologie',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '7323C155LY',
    id: 'course:7eb39b19-403f-46c8-9c9e-f8432fefdb8b',
    name: {
      EN: 'Geopolitical Economy of Energy in Eurasia',
      NL: 'Geopolitical Economy of Energy in Eurasia',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '7515A006FY',
    id: 'course:e51aa67d-6a93-4570-9838-74df78e5f995',
    name: {
      EN: 'Advanced Geographical Information Systems',
      NL: 'Advanced Geographical Information Systems',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '900201SCIY',
    id: 'course:729b5910-4c92-48b4-911a-fd49541a0575',
    name: {
      EN: 'Introduction to Geographic Information Systems',
      NL: 'Introduction to Geographic Information Systems',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '73434E510Y',
    id: 'course:5db4bdea-93cd-4da9-aada-0739411774dc',
    name: {
      EN: 'Geographies of Economic & Financial Disruptions',
      NL: 'Geographies of Economic & Financial Disruptions',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '7515A001FY',
    id: 'course:f39e495f-1f5a-43ac-9444-da809d898d33',
    name: {
      EN: 'Introduction to Geographical Information Systems',
      NL: 'Introduction to Geographical Information Systems',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '734302344Y',
    id: 'course:d47667d9-f6a4-49d6-b0b2-da8e28ba6be1',
    name: {
      EN: 'Bachelor Thesis Project Human Geography & Planning',
      NL: 'Bachelor Thesis Project Human Geography & Planning',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '111321566Y',
    id: 'course:156351d1-0c9a-4bd8-959a-ad7abc83671a',
    name: {
      EN: 'Geopolitics, Developmental Policies and Trade Wars ',
      NL: 'Geopolitics, Developmental Policies and Trade Wars ',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '111321616Y',
    id: 'course:cc388e82-350a-4dc7-8d12-7ac7ff863df5',
    name: {
      EN: 'Europe and the Middle East from a Geopolitical Perspective',
      NL: 'Europe and the Middle East from a Geopolitical Perspective',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '5334MSIA6Y',
    id: 'course:472dfb03-14f4-4613-bfe4-9c2ea67ab1a8',
    name: {
      EN: 'Master Seminar in Algebra, Geometry and Mathematical Physics',
      NL: 'Master Seminar in Algebra, Geometry and Mathematical Physics',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '111221606Y',
    id: 'course:b3faf4c8-55d9-4c25-80f0-0ca651c4b28b',
    name: {
      EN: 'The Geopolitics of Climate Security: A Critical Introduction',
      NL: 'The Geopolitics of Climate Security: A Critical Introduction',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '73435E519Y',
    id: 'course:d9a47cc5-23f0-4a8d-95e2-990af33ba6fe',
    name: {
      EN: 'Specialisation: Geographies of Economic & Financial Disruptions',
      NL: 'Specialisation: Geographies of Economic & Financial Disruptions',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '735420014Y',
    id: 'course:d02a3a3f-aa9e-478f-bbb5-2c96998bedfa',
    name: {
      EN: 'Advanced Urban Geography: Global and Local Perspectives on Cities',
      NL: 'Advanced Urban Geography: Global and Local Perspectives on Cities',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '111221776Y',
    id: 'course:13bc1cc6-a97e-4a43-8622-b5fd6c80f9ea',
    name: {
      EN: 'Post-Cold War Geopolitics and the Emergence of New States In Europe',
      NL: 'Post-Cold War Geopolitics and the Emergence of New States In Europe',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '735420013Y',
    id: 'course:e73cfa8c-f9a4-45f1-9fc1-f9d0712a8701',
    name: {
      EN: 'Advanced Political Geography: Geopolitics, Globalisation & Governance',
      NL: 'Advanced Political Geography: Geopolitics, Globalisation & Governance',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '735420017Y',
    id: 'course:af98944a-d5bb-4639-a5cd-2e6d9ccaed10',
    name: {
      EN: 'Spatial Sustainability: Advanced Environmental Geography and Planning',
      NL: 'Spatial Sustainability: Advanced Environmental Geography and Planning',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '142421306Y',
    id: 'course:75f734c3-64eb-42af-8ce4-9943141d72df',
    name: {
      EN: 'Ukraine’s Plural Geographies: War, Europe, and the Politics of Difference',
      NL: 'Ukraine’s Plural Geographies: War, Europe, and the Politics of Difference',
    },
    programmeType: 'DEGREE',
  },
  {
    code: '7324D102IY',
    id: 'course:1e479f73-1db9-4d93-be81-8e18255059bd',
    name: {
      EN: 'Political Geography: Spatial Inequality and Political Divides in Contemporary Democracies',
      NL: 'Political Geography: Spatial Inequality and Political Divides in Contemporary Democracies',
    },
    programmeType: 'DEGREE',
  },
];

export const MOCK_SEARCH_PROGRAMMES = [
  {
    code: 'SMA_HG',
    id: 'programme:415bf5ce-fd94-45a1-8521-51b31f53dffa',
    name: {
      EN: 'M Human Geography',
      NL: 'M Sociale Geografie',
    },
    programmeType: 'DEGREE',
  },
  {
    code: 'SOM_SG',
    id: 'programme:855fe277-9978-46c6-aa15-5744970a4d92',
    name: {
      EN: 'Minor Human Geography',
      NL: 'Minor Sociale Geografie',
    },
    programmeType: 'CERTIFICATE',
  },
  {
    code: 'NOM_FG',
    id: 'programme:dd50ff50-061b-4a4c-9b2a-c288beeeb919',
    name: {
      EN: 'Minor Fysische Geografie',
      NL: 'Minor Fysische Geografie',
    },
    programmeType: 'CERTIFICATE',
  },
  {
    code: 'SBA_SGP',
    id: 'programme:62c0d7a9-5cca-49ee-96b7-9aa9d2be4b30',
    name: {
      EN: 'B Human Geography and Planning',
      NL: 'B Sociale Geografie en Planologie',
    },
    programmeType: 'DEGREE',
  },
  {
    code: 'SSC_SG30W',
    id: 'programme:ef69e872-df4b-4757-9025-03c353a0be5f',
    name: {
      EN: 'Pre-master Human Geography – wo 30 EC',
      NL: 'Schakelprogramma Sociale Geografie – wo 30 EC',
    },
    programmeType: 'CERTIFICATE',
  },
  {
    code: 'SSC_SG30H',
    id: 'programme:1d4007a1-3988-4bae-9811-827ae2a95ca9',
    name: {
      EN: 'Pre-master Human Geography – hbo 30 EC',
      NL: 'Schakelprogramma Sociale Geografie – hbo 30 EC',
    },
    programmeType: 'CERTIFICATE',
  },
  {
    code: 'SSC_SG60H',
    id: 'programme:f12f7a57-5699-4ec3-b90d-c27ac09c67ea',
    name: {
      EN: 'Pre-master Human Geography – hbo 60 EC',
      NL: 'Schakelprogramma Sociale Geografie – hbo 60 EC',
    },
    programmeType: 'CERTIFICATE',
  },
];
